import Vue from 'vue';
import Vuex from 'vuex';

import currentPage from '@/store/modules/currentPage';
import setup from '@/store/modules/setup';
import auth from '@/store/modules/auth';

// install Vuex
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
    modules: {
        setup, // global
        auth, // namespaced
        currentPage // namespaced
    },
    strict: debug
});

export default store;
